var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bed-icon",
    transform: "translate(-5367 -432)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 31,
    height: 31,
    transform: "translate(5367 432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bed-icon-2",
    "data-name": "bed-icon",
    d: "M25.447,14.226v-10a1.222,1.222,0,1,0-2.445,0V5.445H5.889V4.222a1.222,1.222,0,0,0-2.445,0v10A3.667,3.667,0,0,0,1,17.668V23.78a1.222,1.222,0,1,0,2.445,0V22.558h22V23.78a1.222,1.222,0,1,0,2.445,0V17.668a3.667,3.667,0,0,0-2.445-3.442ZM23,14H21.78V11.556a1.222,1.222,0,0,0-1.222-1.222H8.334a1.222,1.222,0,0,0-1.222,1.222V14H5.889V7.889H23ZM9.556,14V12.779h3.667V14Zm6.112-1.222h3.667V14H15.668ZM3.445,17.668a1.222,1.222,0,0,1,1.222-1.222H24.225a1.222,1.222,0,0,1,1.222,1.222v2.445h-22Z",
    transform: "translate(5367.566 433.999)",
    fill: "#4332d5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bed-icon.7f932aba.svg";
export { ForwardRef as ReactComponent };